import { createElement } from "./dom_utils.js";

/**
 * End-call confirmation dialog component.
 *
 * @param {Object} opts
 * @param {Function} opts.onConfirm - Called when user confirms ending the call
 * @param {Function} opts.onCancel  - Called when user cancels
 * @param {Object}   opts.employee  - Employee config (for CTA)
 * @returns {{ el: HTMLElement, destroy: Function }}
 */
export function createEndDialog({ onConfirm, onCancel, employee }) {
  const overlay = createElement("div", { className: "sm-dialog-overlay" });

  // Center content area (title + subtitle + CTA)
  const center = createElement("div", { className: "sm-dialog-center" });

  const header = createElement("div", { className: "sm-dialog-header" });
  header.appendChild(createElement("p", { className: "sm-dialog-title" }, "End this conversation"));
  header.appendChild(
    createElement("p", { className: "sm-dialog-desc" }, "Are you sure you want to end this conversation?"),
  );
  center.appendChild(header);

  // CTA button if configured
  const endWin = employee?.cta_config?.end_chat_window;
  if (endWin?.enabled && endWin?.primary_call_to_action_text) {
    const ctaWrap = createElement("div", { className: "sm-dialog-cta-wrap" });
    const ctaBtn = createElement(
      "button",
      { className: "sm-dialog-cta-btn" },
      endWin.primary_call_to_action_text,
    );
    ctaBtn.addEventListener("click", () => {
      let url = endWin.redirect_url || "";
      if (url && !url.match(/^https?:\/\//i)) url = "https://" + url;
      if (url) window.open(url, "_blank", "noopener");
    });
    ctaWrap.appendChild(ctaBtn);
    center.appendChild(ctaWrap);
  }

  overlay.appendChild(center);

  // Bottom action buttons
  const actions = createElement("div", { className: "sm-dialog-actions" });
  const endBtn = createElement("button", { className: "sm-dialog-action-btn" }, "End Chat");
  const stayBtn = createElement("button", { className: "sm-dialog-action-btn" }, "Stay Back");
  actions.appendChild(endBtn);
  actions.appendChild(stayBtn);
  overlay.appendChild(actions);

  // Click handlers
  endBtn.addEventListener("click", onConfirm);
  stayBtn.addEventListener("click", onCancel);
  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) onCancel();
  });
  center.addEventListener("click", (e) => e.stopPropagation());
  actions.addEventListener("click", (e) => e.stopPropagation());

  function destroy() {
    endBtn.removeEventListener("click", onConfirm);
    stayBtn.removeEventListener("click", onCancel);
    overlay.remove();
  }

  return { el: overlay, destroy };
}
